import { connect } from 'react-redux';
import Selector from './Selector';
import { setFilters } from '../../filters/store/filtersSlice';
import { setMobileDrawerOpen } from '../../mobile-drawer/store/mobileDrawerSlice';
import { getSelectorsData } from '../store/authorizationSequencingSlice';

const mapState = state => {
  const { selectedIndex } = state.loadingManagement.filters;
  const filteredSelectors = getSelectorsData(state);
  const selectorsList = state.loadingManagement.authorizationSequencing.selectorsList || [];
  const selectedNameShort = selectorsList[selectedIndex]?.nameShort;

  return {
    selected: selectedNameShort
      ? filteredSelectors.findIndex(({ nameShort }) => nameShort === selectedNameShort)
      : selectedIndex,
  };
};

const mapDispatchToProps = {
  setMobileDrawerOpen,
  setSelected: nameShort => (dispatch, getState) => {
    const { selectorsList } = getState().loadingManagement.authorizationSequencing;
    const selectedIndex = (selectorsList || []).findIndex(
      selector => selector?.nameShort === nameShort
    );

    if (selectedIndex >= 0) {
      dispatch(setFilters({ name: 'selectedIndex', value: selectedIndex }));
    }
  },
};

export default connect(mapState, mapDispatchToProps)(Selector);
